export const SET_PAPER_SUCCESS = "SET_PAPER_SUCCESS";
export const ADD_PAPER_SUCCESS = "ADD_PAPER_SUCCESS";
export const EDIT_PAPER_SUCCESS = "EDIT_PAPER_SUCCESS";
export const DELETE_PAPER_SUCCESS = "DELETE_PAPER_SUCCESS";
